<template>
    <div class="root-container">
        <!--数字概览-->
        <el-row class="box-header">
            <el-col class="title-text-container" v-for="(title,index) in titles" :span="6">
                <div class="title-text">{{title}}</div>
            </el-col>
        </el-row>
        <el-row class="box-main">
            <el-col class="value-text-container" v-for="(value,index) in values" :span="6">
                <div class="value-text">{{value}}</div>
            </el-col>
        </el-row>
        <!--地图-->
        <el-row :gutter="0" class="box-header" style="margin-top: 30px">
            <el-col class="chart-title-text-container" :span="12">
                <div class="chart-title-text">设备区域分布</div>
            </el-col>
        </el-row>
        <div id="id_heatmap" style="width: 100%;height: 100%;"/>
    </div>
</template>

<script>
    import echarts from "echarts"
    import 'echarts/extension/bmap/bmap.js'
    import {GetOverviewInfo} from "../api/api";

    export default {
        data() {
            return {
                token: '',
                titles: ['实时在线设备数量', '昨日活跃设备数量', '历史累计上线设备数量', '历史累计上线次数'],
                values: [-1, -1, -1, -1],
                notes: [],
                span: 1
            }
        },
        methods: {
            initMap(chart, data) {
                var mchart = echarts.init(chart);
                mchart.setOption({
                    animation: false,
                    bmap: {
                        center: [104.16181, 37.417],//[120.13066322374, 30.240018034923],
                        zoom: 5,
                        roam: false
                    },
                    visualMap: {
                        show: false,
                        top: 'top',
                        min: 0,
                        max: 5,
                        seriesIndex: 0,
                        calculable: true,
                        inRange: {
                            color: ['blue', 'blue', 'green', 'yellow', 'red']
                        }
                    },
                    series: [{
                        type: 'heatmap',//scatter
                        coordinateSystem: 'bmap',
                        data: data,
                        pointSize: 5,
                        blurSize: 6
                    }]
                });
                var bmap = mchart.getModel().getComponent('bmap').getBMap();
                var navigationCtrl = new BMap.NavigationControl({
                    anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
                    type: BMAP_NAVIGATION_CONTROL_LARGE
                });
                bmap.addControl(navigationCtrl);
                // bmap.addControl(new BMap.MapTypeControl());
                /*缩放控件type有四种类型:
                BMAP_NAVIGATION_CONTROL_LARGE：标准
                BMAP_NAVIGATION_CONTROL_SMALL：仅包含平移和缩放按钮；
                BMAP_NAVIGATION_CONTROL_PAN:仅包含平移按钮；
                BMAP_NAVIGATION_CONTROL_ZOOM：仅包含缩放按钮
                */
                bmap.setMapStyle({style: 'grayscale'});
            }
        },
        created() {
            this.token = sessionStorage.getItem("BBRtoken");
        },
        mounted() {
            var that = this;
            // 请求数据
            GetOverviewInfo({token: this.token}).then(res => {
                that.values = [
                    res.data.summary.online_quantity,
                    // res.data.summary.today_new_online_quantity,
                    res.data.summary.yesterday_active_device_quantity,
                    res.data.summary.total_online_device_quantity,
                    res.data.summary.total_online_quantity
                ];
            }).catch(err => {
            });

            var heatmapChart = document.getElementById('id_heatmap');
            var heatmapdata = require('../assets/heatmapdata');
            that.initMap(heatmapChart, heatmapdata);
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AnalyzeOverviewManagement.vue?199bed81